import { Menu, MenuContent, MenuItem, MenuLabel, MenuSeparator, MenuTrigger } from '@bifeai/ui';
import { Building2, ChevronDown, Network, Store } from 'lucide-react';
import { useSession } from '../lib/session';

/**
 * Selector de sucursal. La casa central elige ver una sucursal o todas juntas.
 * Un usuario de sucursal ve fija la suya (no puede cambiarla).
 */
export function BranchPicker() {
  const { me, isHeadquartersUser, selectedBranchId, setSelectedBranchId } = useSession();
  const current = me.branches.find((b) => b.id === selectedBranchId);
  const own = me.branches.filter((b) => !b.franchise);
  const franchises = me.branches.filter((b) => b.franchise);
  // Con franquicias, "Todas" son los locales propios: las franquicias son otra empresa y se ven aparte.
  const allLabel = franchises.length ? 'Todos los locales propios' : 'Todas las sucursales';
  const label = current?.name ?? allLabel;

  if (!isHeadquartersUser) {
    return (
      <span className="bf-picker" aria-label={`Sucursal: ${label}`} style={{ cursor: 'default' }}>
        <Store />
        <span>{label}</span>
      </span>
    );
  }

  return (
    <Menu>
      <MenuTrigger asChild>
        <button type="button" className="bf-picker" aria-label={`Sucursal: ${label}. Cambiar`}>
          <Building2 />
          <span>{label}</span>
          <ChevronDown />
        </button>
      </MenuTrigger>
      <MenuContent>
        <MenuLabel>Ver datos de</MenuLabel>
        <MenuItem icon={<Building2 />} checked={!selectedBranchId} onSelect={() => setSelectedBranchId(null)}>
          {allLabel}
        </MenuItem>
        <MenuSeparator />
        {own.map((b) => (
          <MenuItem key={b.id} icon={<Store />} checked={b.id === selectedBranchId} onSelect={() => setSelectedBranchId(b.id)}>
            {b.name}
            {b.isHeadquarters ? ' (central)' : ''}
          </MenuItem>
        ))}
        {franchises.length > 0 && (
          <>
            <MenuSeparator />
            <MenuLabel>Franquicias</MenuLabel>
            {franchises.map((b) => (
              <MenuItem key={b.id} icon={<Network />} checked={b.id === selectedBranchId} onSelect={() => setSelectedBranchId(b.id)}>
                {b.name}
              </MenuItem>
            ))}
          </>
        )}
      </MenuContent>
    </Menu>
  );
}
